export default function VisionQuoteText({ quote }) {
  return <p className="mt-6 text-2xl font-medium text-white">{quote}</p>;
}
